import script from "./StudentDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./StudentDashboard.vue?vue&type=style&index=0&id=f791000e&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f791000e"]])

export default __exports__